import FolderSharedRoundedIcon from "@mui/icons-material/FolderSharedRounded";
import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  Modal,
  Paper,
  Switch,
  TextField,
  Typography,
  styled,
  Tabs,
  Tab
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { decode } from "base-64";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import "../card.css";
import PropTypes from 'prop-types';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "3px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  minHeight: "50px",
  borderRadius: "10px",
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const UsersPage = (isOnline) => {
  const [allUsers, setAllUsers] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [messageid, setMessageid] = useState();
  const [all_soc, setAll_soc] = useState([]);
  const [open_new, setOpen_new] = useState(false);
  const [checked, setChecked] = useState(false);
  const [edit_data, setEdit_data] = useState([]);
  const [edit_mode, setEdit_mode] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const society_id = location.state && location.state.society_id;
  const society_name = location.state && location.state.name;
  const [value1, setValue1] = useState(0);

  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };

  const goToSalary = () => {
    navigate('/salaries',{ state: {
      society_id: society_id
    } })
  }

  const editUser = (row) => {
    setEdit_mode(true);
    setEdit_data(row)
    setOpen_new(true)
    formik.setFieldValue("dob", row.dob)
    formik.setFieldValue("address", row.address)
    formik.setFieldValue("phone", row.phone)
    formik.setFieldValue("firstName", row.firstName)
    formik.setFieldValue("middleName", row.middleName)
    formik.setFieldValue("lastName", row.lastName)
    formik.setFieldValue("email", row.email)
    formik.setFieldValue("username", row.username)
    formik.setFieldValue("password", row.password)
    formik.setFieldValue("marital_status", row.marital_status)
    formik.setFieldValue("sinn_number", row.sinn_number)
    formik.setFieldValue("basic_salary", row.basic_salary)
    formik.setFieldValue("bank_name", row.bank_name)
    formik.setFieldValue("account_name", row.account_name)
    formik.setFieldValue("account_number", row.account_number)
    formik.setFieldValue("gra_pin", row.gra_pin)
    formik.setFieldValue("crn", row.crn)
    formik.setFieldValue("staff", row.staff)
    formik.setFieldValue("society_id2", row.society_id2)
    formik.setFieldValue("society_id3", row.society_id3)
    formik.setFieldValue("society_id", row.society_id)
  }

  const closeNew = () => {
    setOpen_new(false);
    formik.handleReset();
    setEdit_mode(false);
    setEdit_data([]);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxHeight: "80vh",
    minHeight: "70vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const fetch_soc = () => {
    const storedSocieties = localStorage.getItem("all_societies");

    if (storedSocieties) {
      setAll_soc(JSON.parse(storedSocieties));
    } else {
      api
        .get("/association/societies/allshch", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setAll_soc(response.data?.Society);
          localStorage.setItem(
            "all_societies",
            JSON.stringify(response.data?.Society)
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const handleClickOpen = (id) => {
    setOpen(true);
    setMessageid(id);
  };
  const [allRoles, setAllRoles] = useState([]);

  const fetchRoles = () => {
    const storedRoles = localStorage.getItem("roles");

    if (!isOnline) {
      setAllRoles(JSON.parse(storedRoles));
    } else {
      api
        .get("/auth/all/roles", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setAllRoles(response.data);
          localStorage.setItem("roles", JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    fetchRoles();
    fetch_soc();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const fetchAllUsers = () => {
    const data = new FormData()
    data.append('which', value1)
    data.append('society_id', society_id)
    toast.promise(
      api
      .post(`/users/user/filter`, data ,{
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: 'Fetching Users...',
        success: (response) => {
          setAllUsers(response.data);

          return "Data Loaded Successfully"
        },
        error: (error) => {
          console.log(error);

          return "An Error Occurred, Please refresh"
        }
      }
    )
  };


  useEffect(() => {
      fetchAllUsers();
  }, [value1]);

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };
  // console.log(allUsers)

  const handleDeleteUser = () => {
    api
      .delete(`/users/user/delete/${messageid}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        handleClose();
        setMessageid();
        fetchAllUsers();
      })
      .catch(function (error) {
        console.log(error);
        handleClose();
      });
  };

  const formik = useFormik({
    initialValues: {
      dob: "",
      gender: "",
      address: "",
      phone: "",
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      username: "",
      password: "",
      marital_status: "",
      sinn_number: "",
      basic_salary: null,
      bank_name: "",
      account_name: "",
      account_number: null,
      role_id: null,
      society_id: society_id,
      society_id2: null,
      society_id3: null,
      gra_pin: null,
      crn: null,
      staff: false,
    },
    onSubmit: (values) => {
      const newData = new FormData();
      newData.append("dob", values.dob);
      newData.append("address", values.address);
      newData.append("phone", values.phone);
      newData.append("firstName", values.firstName);
      newData.append("middleName", values.middleName);
      newData.append("lastName", values.lastName);
      newData.append("email", values.email);
      newData.append("username", values.username);
      newData.append("hashed_password", values.password);
      newData.append("marital_status", values.marital_status);
      newData.append("sinn_number", values.sinn_number);
      newData.append("bank_name", values.bank_name);
      newData.append("account_name", values.account_name);
      newData.append("gra_pin", values.gra_pin);
      newData.append("crn", values.crn);
      newData.append("staff", values.staff || false);
      newData.append("society_id", values.society_id);
      // console.log(values.society_id)



      if (values.society_id2 !== null) {
        newData.append("society_id2", values.society_id2);
      }
      if (values.society_id3 !== null) {
        newData.append("society_id3", values.society_id3);
      }
      if (values.gender !== null) {
        newData.append("gender", values.gender);
      }
      if (values.basic_salary !== null) {
        newData.append("basic_salary", values.basic_salary);
      }
      if (values.role_id !== null) {
        newData.append("role_id", values.role_id);
      }
      if (values.sinn_number !== null) {
        newData.append("sinn_number", values.sinn_number);
      }
      if (edit_mode) {
        newData.append("user_id", edit_data.id);
      }
      if (values.middleName !== "") {
        newData.append("middleName", values.middleName);
      }
      if (values.lastName !== "") {
        newData.append("lastName", values.lastName);
      }
      if (values.phone !== "") {
        newData.append("phone", values.phone);
      }
      if (values.basic_salary !== null) {
        newData.append("basic_salary", values.basic_salary);
      }
      if (values.account_number !== null) {
        newData.append("account_number", values.account_number);
      }

      toast.promise(
        api.post("/auth/create/user", newData, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        }),
        {
          loading: edit_mode?"Updating User...": "Registering New User... ",
          success: (response) => {
            closeNew();
            fetchAllUsers();

            return response.data;
          },
          error: (error) => {
            console.log(error);

            return "An error occurred, Please refresh.";
          },
        }
      );
    },
  });

  useEffect(() => {
    if (checked) {
      formik.setFieldValue("society_id", 0);
      formik.setFieldValue("society_id2", null);
      formik.setFieldValue("society_id3", null);
    } else {
      formik.setFieldValue("society_id", society_id);
    }
  }, [checked]);

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 3 }}>
          <Typography
            sx={{ textAlign: "center" }}
            variant="h4"
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
          >
            <b>{society_name}' Users</b>
          </Typography>
          <Box>
            <Button
              size="small"
              color="success"
              variant="contained"
              sx={{
                m: 3,
                borderRadius: 2,
                boxShadow:
                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  boxShadow:
                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                  backgroundColor: "#14213d",
                },
              }}
              onClick={() => setOpen_new(true)}
            >
              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Add New Staff</b>
              </Typography>
            </Button>
            
            <Button
              size="small"
              color="success"
              variant="contained"
              sx={{
                m: 3,
                borderRadius: 2,
                boxShadow:
                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  boxShadow:
                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                  backgroundColor: "#14213d",
                },
              }}
              onClick={goToSalary}
            >
              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Salaries</b>
              </Typography>
            </Button>
          </Box>
          
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value1} onChange={handleChange1} aria-label="basic tabs example">
                <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>All Users</b>} {...a11yProps(0)} />
                <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Staff</b>} {...a11yProps(1)} />
                <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Non-Staff</b>} {...a11yProps(2)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value1} index={0}>
              <Box
                sx={{
                  overflow: "auto",
                  marginBottom: 10,
                  maxHeight: 340,
                  "&::-webkit-scrollbar": {
                    width: "7px",
                    height: "7px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#888",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#555",
                  },
                }}
              >
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>No.</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Profile Picture</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>User Name</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>User Pwd</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Contact Phone</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Main Society</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Role</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Update User</b>
                        </Typography>{" "}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {allUsers?.map((row, index) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                          backgroundColor: "#f5f3f4",
                        }}
                      >
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{index + 1}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <Avatar src={pic(row.userImage)} />
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.username}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.password}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.phone}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.society}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.role}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <Button
                              size="small"
                              color="success"
                              variant="contained"
                              sx={{
                                borderRadius: 2,
                                boxShadow:
                                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                "&:hover": {
                                  boxShadow:
                                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                  backgroundColor: "#14213d",
                                },
                              }}
                              onClick={() => editUser(row)}
                            >
                              <FolderSharedRoundedIcon />
                            </Button>
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value1} index={1}>
            <Box
                sx={{
                  overflow: "auto",
                  marginBottom: 10,
                  maxHeight: 340,
                  "&::-webkit-scrollbar": {
                    width: "7px",
                    height: "7px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#888",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#555",
                  },
                }}
              >
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>No.</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Profile Picture</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>User Name</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>User Pwd</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Contact Phone</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Main Society</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Role</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Update User</b>
                        </Typography>{" "}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {allUsers?.map((row, index) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                          backgroundColor: "#f5f3f4",
                        }}
                      >
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{index + 1}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <Avatar src={pic(row.userImage)} />
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.username}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.password}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.phone}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.society}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.role}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <Button
                              size="small"
                              color="success"
                              variant="contained"
                              sx={{
                                borderRadius: 2,
                                boxShadow:
                                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                "&:hover": {
                                  boxShadow:
                                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                  backgroundColor: "#14213d",
                                },
                              }}
                              onClick={() => editUser(row)}
                            >
                              <FolderSharedRoundedIcon />
                            </Button>
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value1} index={2}>
            <Box
                sx={{
                  overflow: "auto",
                  marginBottom: 10,
                  maxHeight: 340,
                  "&::-webkit-scrollbar": {
                    width: "7px",
                    height: "7px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#888",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#555",
                  },
                }}
              >
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>No.</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Profile Picture</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>User Name</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>User Pwd</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Contact Phone</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Main Society</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Role</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Update User</b>
                        </Typography>{" "}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {allUsers?.map((row, index) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                          backgroundColor: "#f5f3f4",
                        }}
                      >
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{index + 1}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <Avatar src={pic(row.userImage)} />
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.username}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.password}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.phone}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.society}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.role}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <Button
                              size="small"
                              color="success"
                              variant="contained"
                              sx={{
                                borderRadius: 2,
                                boxShadow:
                                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                "&:hover": {
                                  boxShadow:
                                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                  backgroundColor: "#14213d",
                                },
                              }}
                              onClick={() => editUser(row)}
                            >
                              <FolderSharedRoundedIcon />
                            </Button>
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </CustomTabPanel>
          </Box>

          
          {/* table box end here */}
        </Box>

        <Modal
          open={open_new}
          onClose={closeNew}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Grid container spacing={1}>
              <Grid xs={12} md={12}>
                <Typography
                  sx={{ textAlign: "center" }}
                  variant="h4"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>{edit_mode? "User Details": "Register New User"}</b>
                </Typography>
              </Grid>
              {/* Personal Details */}
              <Grid item xs={12} md={4}>
                <Item>
                  <Typography
                    sx={{ textAlign: "center" }}
                    variant="h5"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Personal Details</b>
                  </Typography>

                  <Divider sx={{ m: 0.5 }} />

                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    required
                    name="firstName"
                    type="text"
                    value={formik.values.firstName}
                    onChange={formik.handleChange}
                    placeholder="First Name"
                    helperText="First Name"
                    fullWidth
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="middleName"
                    type="text"
                    value={formik.values.middleName}
                    onChange={formik.handleChange}
                    placeholder="Middle Name"
                    helperText="Middle Name"
                    fullWidth
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="lastName"
                    type="text"
                    value={formik.values.lastName}
                    onChange={formik.handleChange}
                    placeholder="Last Name"
                    helperText="Last Name"
                    fullWidth
                  />

                  <Autocomplete
                    id="tags-outlined"
                    options={[
                      { id: "Male", value: "Male" },
                      { id: "Female", value: "Female" },
                    ]}
                    sx={{ mt: 2 }}
                    getOptionLabel={(option) => option.value}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.id
                    }
                    onChange={(event, value) =>
                      formik.setFieldValue("gender", value.id)
                    }
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Gender"
                        helperText="Gender"
                        size="small"
                        fullWidth
                      />
                    )}
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    required
                    size="small"
                    name="dob"
                    type="datetime-local"
                    value={formik.values.dob}
                    onChange={formik.handleChange}
                    helperText="Date of Birth"
                    fullWidth
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="address"
                    type="text"
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    placeholder="Home Address"
                    helperText="Home Address"
                    fullWidth
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="phone"
                    type="text"
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                    placeholder="Contact Phone"
                    helperText="Contact Phone"
                    fullWidth
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="email"
                    type="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    placeholder="Email"
                    helperText="Email"
                    fullWidth
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="marital_status"
                    type="text"
                    value={formik.values.marital_status}
                    onChange={formik.handleChange}
                    placeholder="Marital Status"
                    helperText="Marital Status"
                    fullWidth
                  />
                </Item>
              </Grid>
              {/* UserAccess Details */}
              <Grid item xs={12} md={4}>
                <Item>
                  <Typography
                    sx={{ textAlign: "center" }}
                    variant="h5"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>User Access Details</b>
                  </Typography>

                  <Divider sx={{ m: 0.5 }} />

                  <TextField
                    sx={{ m: 0.5 }}
                    required
                    size="small"
                    name="username"
                    type="text"
                    value={formik.values.username}
                    onChange={formik.handleChange}
                    placeholder="User Name (for log in)"
                    helperText="User Name (for log in)"
                    fullWidth
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    required
                    size="small"
                    name="password"
                    type="text"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    placeholder="Password"
                    helperText="Password"
                    fullWidth
                  />

                  <div style={{ display: "flex" }}>
                    <Typography
                      sx={{ margin: "5px" }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Access To All Societies</b>
                    </Typography>
                    <Switch
                      checked={checked}
                      onChange={() => setChecked(event.target.checked)}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>

                  {
                    formik.values.society_id !== 0?
                    <Autocomplete
                      id="tags-outlined"
                      options={all_soc}
                      sx={{ mt: 2 }}
                      getOptionLabel={(option) => option.society}
                      isOptionEqualToValue={(option, value) =>
                        option.society === value.id
                      }
                      onChange={(event, value) =>
                        formik.setFieldValue("society_id2", value.id)
                      }
                      filterSelectedOptions
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={edit_mode && edit_data.society2?edit_data.society2:"2nd Society"}
                          size="small"
                          helperText={edit_mode && edit_data.society2?edit_data.society2:"2nd Society"}
                          fullWidth
                        />
                      )}
                    />
                    :null
                  }
                  {
                    formik.values.society_id !== 0?
                    <Autocomplete
                      id="tags-outlined"
                      options={all_soc}
                      sx={{ mt: 2 }}
                      getOptionLabel={(option) => option.society}
                      isOptionEqualToValue={(option, value) =>
                        option.society === value.id
                      }
                      onChange={(event, value) =>
                        formik.setFieldValue("society_id3", value.id)
                      }
                      filterSelectedOptions
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={edit_mode && edit_data.society3?edit_data.society3:"3rd Society"}
                          size="small"
                          helperText={edit_mode && edit_data.society3?edit_data.society3:"3rd Society"}
                          fullWidth
                        />
                      )}
                    />
                    :null
                  }

                  <Autocomplete
                    id="tags-outlined"
                    options={allRoles}
                    sx={{ mt: 2 }}
                    getOptionLabel={(option) => option.role_name}
                    isOptionEqualToValue={(option, value) =>
                      option.role_name === value.id
                    }
                    onChange={(event, value) =>
                      formik.setFieldValue("role_id", value.id)
                    }
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Role"
                        size="small"
                        helperText={edit_mode?edit_data.role:"Role"}
                        fullWidth
                      />
                    )}
                  />

                  <TextField  
                    sx={{ m: 0.5 }}
                    required
                    size="small"
                    name="crn"
                    type="text"
                    value={formik.values.crn}
                    onChange={formik.handleChange}
                    placeholder="Cooperative Registration Number"
                    helperText="Cooperative Registration Number"
                    fullWidth
                  />
                </Item>
              </Grid>
              {/* Accounts Details */}
              <Grid item xs={12} md={4}>
                <Item>
                  <Typography
                    sx={{ textAlign: "center" }}
                    variant="h5"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Account Details</b>
                  </Typography>

                  <Divider sx={{ m: 0.5 }} />

                  <TextField
                    sx={{ m: 0.5 }}
                    required
                    size="small"
                    name="bank_name"
                    type="text"
                    value={formik.values.bank_name}
                    onChange={formik.handleChange}
                    placeholder="Account Provider (MTN/Fidelity bank/Telecel etc)"
                    helperText="Account Provider (MTN/Fidelity bank/Telecel etc)"
                    fullWidth
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    required
                    size="small"
                    name="account_name"
                    type="text"
                    value={formik.values.account_name}
                    onChange={formik.handleChange}
                    placeholder="Name On Account"
                    helperText="Name On Account"
                    fullWidth
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    required
                    size="small"
                    name="account_number"
                    type="text"
                    value={formik.values.account_number}
                    onChange={formik.handleChange}
                    placeholder="Account Number"
                    helperText="Account Number"
                    fullWidth
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    required
                    size="small"
                    name="basic_salary"
                    type="text"
                    value={formik.values.basic_salary}
                    onChange={formik.handleChange}
                    placeholder="Gross Salary"
                    helperText="Gross Salary"
                    fullWidth
                  />

                  <div style={{ display: "flex" }}>
                    <Typography
                      sx={{ margin: "5px" }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>
                        Is User a staff? (staffs enjoy's SNNIT'S benefits)
                      </b>
                    </Typography>
                    <Switch
                      checked={formik.values.staff}
                      onChange={() => formik.setFieldValue("staff", event.target.checked)}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                    {
                      formik.values.staff?
                      <TextField
                        sx={{ m: 0.5 }}
                        required
                        size="small"
                        name="sinn_number"
                        type="text"
                        value={formik.values.sinn_number}
                        onChange={formik.handleChange}
                        placeholder="SSNIT Number"
                        helperText="SSNIT Number"
                        fullWidth
                      />
                      :null
                    }
                  

                  <TextField  
                    sx={{ m: 0.5 }}
                    required
                    size="small"
                    name="gra_pin"
                    type="text"
                    value={formik.values.gra_pin}
                    onChange={formik.handleChange}
                    placeholder="GRA PIN"
                    helperText="GRA PIN"
                    fullWidth
                  />
                </Item>
              </Grid>

              <Grid item xs={12} md={8}></Grid>
              <Grid item xs={12} md={4}>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Button
                    size="small"
                    color="error"
                    variant="contained"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                    onClick={closeNew}
                  >
                    Cancel
                  </Button>

                  <Button
                    size="small"
                    color="success"
                    variant="contained"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                    onClick={formik.handleSubmit}
                  >
                    {edit_mode?"Complete update":"Complete Registration"}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </main>
    </div>
  );
};
